/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Fragment } from 'react'

import { condicoesQueAlteramDente } from '../../odontograma-field/model'
import { CounterTooltip } from '../components/CounterTooltip'
import { DenteModel, DenteProps } from '../types/Dente'

type DenteEventsProps = {
  onClick?(ref?: SVGSVGElement): void
  onFocus?(): void
  onBlur?(): void
  disableStateEffects?: boolean
  disabled?: boolean
}

export const dentePossuiCondicoesQueAlteram = (dente: DenteModel) =>
  dente?.condicoes?.some((item) => condicoesQueAlteramDente.includes(item))

export const getDenteEvents = (props: DenteEventsProps) => {
  const ESPACO_KEY = 32

  return {
    focusable: !props.disableStateEffects && !props.disabled,
    tabIndex: props.disableStateEffects || props.disabled ? -1 : 0,
    onFocus: props.onFocus,
    onBlur: props.onBlur,
    onClick: (ref) => !props.disabled && props.onClick && props.onClick(ref),
    onKeyDown: (e) => {
      if (e.keyCode === ESPACO_KEY) {
        e.preventDefault()
        !props.disabled && props.onClick && props.onClick()
      }
    },
  }
}

export interface DenteWrapperProps extends Omit<DenteProps, 'innerRef'> {
  placement: 'superior' | 'inferior'
  children: JSX.Element
}

export function DenteWrapper(props: DenteWrapperProps) {
  const { tooltipNumber, tooltipText, placement, children, disabled, style, value } = props
  const classes = denteWrapperStyles()

  return (
    <div css={[classes.denteContainer, style]}>
      <Fragment>
        {!disabled && (
          <CounterTooltip
            position={placement === 'inferior' ? { top: '2.625rem' } : { bottom: '2.625rem' }}
            value={tooltipNumber || value?.tooltipNumber}
            text={tooltipText || value?.tooltipText}
          />
        )}

        {children}
      </Fragment>
    </div>
  )
}

export const denteWrapperStyles = () => ({
  denteContainer: css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    position: relative;
  `,
})
